<template>
  <li id="BackTop" v-if="btnFlag" @click="BackTop()" title="回到顶部"></li>
</template>
<script>
export default {
  name: "BackTop",
  data() {
    return {
      btnFlag: false
    };
  },
  // vue的两个生命钩子，这里不多解释。
  // window对象，所有浏览器都支持window对象。它表示浏览器窗口，监听滚动事件
  mounted () {
    window.addEventListener('scroll', this.scrollToTop)
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    BackTop () {
      const that = this
      let timer = setInterval(() => {
      let ispeed = Math.floor(-that.scrollTop / 5)
      document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
      if (that.scrollTop === 0) {
        clearInterval(timer)
      }
      }, 16)
    },
    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop () {
      const that = this
      let scrollTop = window.pageYOffset 
      || document.documentElement.scrollTop 
      || document.body.scrollTop
      that.scrollTop = scrollTop
      if (that.scrollTop > 60) {
        that.btnFlag = true
        $(".rightSide").css("height","80")
      } else {
        that.btnFlag = false
        $(".rightSide").css("height","42")
      }
    }
  }
};
</script>
<style scoped>
  #BackTop{
    background: url('../../assets/images/rightSide/rightside_backtop_normal.png') no-repeat;
    background-size: 100% 100%;
  }
  #BackTop:hover{
    background: url('../../assets/images/rightSide/rightside_backtop_hover.png') no-repeat;
    background-size: 100% 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/BackTop.vue